export { MyCheckbox } from './MyCheckbox';
export { MySelect } from './MySelect';
export { MyTextInput } from './MyTextInput';
export { BtnBack } from './BtnBack'
export { MyTable } from './MyTable'
export { MyLink } from './MyLink'
export { BtnNewSmall } from './BtnNewSmall'
export { MySpinner } from './MySpinner'

